import { Button } from "@omni/ui/components/Button/button.component";

import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";

type Props = {
    title: string;
    text?: string;
    onClick?: () => void;
    buttonText?: string;
};

const BonusCardFeedback = ({ title, text, buttonText, onClick }: Props) => (
    <>
        <h4>{title}</h4>
        {text && <p>{text}</p>}
        {onClick && buttonText && (
            <Row>
                <Col
                    xs={12}
                    md={5}
                    lg={4}
                    className={"d-flex align-items-center mb-3"}
                >
                    <div className={"mt-md-3 w-100"}>
                        <Button
                            test="bonusCardFeedBack-button"
                            type="button"
                            onClick={onClick}
                        >
                            {buttonText}
                        </Button>
                    </div>
                </Col>
            </Row>
        )}
    </>
);

export { BonusCardFeedback };
